import type { ComponentProps } from 'react'
import EmergencyNotes from '../../shared/EmergencyNotes'

type Props = ComponentProps<typeof EmergencyNotes>

export default function Step5_EmergencyNotes(props: Props) {
  return <EmergencyNotes {...props} />
}

